{
  "nl": {
    "employee": {
      "actions": {
        "accessProjects": "Toegang tot projecten beheren",
        "cancel": "Cancel",
        "changeProfilePicture": "Verander profielfoto",
        "change_role": "Rol wijzigen naar",
        "download": "Download",
        "new": "Teamlid",
        "profilePictureFormat": "Moet vierkant formaat zijn, min. 300x300px",
        "save": "Opslaan",
        "searchEmployee": "Zoek Teamlid",
        "sendinvitation": "Maak aan en verstuur uitnodiging",
        "submit": "Opslaan",
        "undoChanges": "Annuleer"
      },
      "attributes": {
        "email_address": "Email",
        "email_notifications_interval": {
          "daily": "Een keer per dag (rond het middaguur)",
          "hourly": "Elk uur",
          "twice_daily": "Tweemaal per dag (ochtend/middag)",
          "weekly": "Een keer per week (maandagmiddag)"
        },
        "first_name": "Voornaam",
        "language": "Taal",
        "last_name": "Achternaam",
        "phone_landline": "Vast nummer",
        "phone_mobile": "Mobiel nummer",
        "profession": "Functie",
        "role": "Toegangsrechten",
        "signature_html": "Handtekening gesprekken",
        "status": "Status",
        "title": "Titel"
      },
      "integrations": {
        "hide_details": "Verberg details",
        "last_synced_at": "Laatst gesynchroniseerd op: {time}",
        "show_details": "Toon details"
      },
      "labels": {
        "all_projects": "Alle projecten",
        "confirmChangeRoleTitle": "Rol wijzigen naar {role}?",
        "confirmChangeRoleToMaintainer": "Let op: {name} verliest hierdoor toegang tot alle projecten en alle bestaande notificaties worden verwijderd. Je kan {name} daarna opnieuw als beheerder aan projecten toewijzen.",
        "confirmChangeRoleToOwner": "{name} krijgt hierdoor toegang tot alle projecten en alle inhoud op het platform.",
        "confirmPasswordReset": "Een email is verzonden met een link voor een wachtwoordwijziging, gelieve je inbox te controleren. Contacteer ons indien je problemen ondervindt.",
        "disabled": {
          "access": "We verlenen alle medewerkers toegang tot het platform vanaf het moment dat de laatste achterstallige factuur is betaald.",
          "contact": "Neem contact op",
          "overdue": "We hebben gemerkt dat jouw laatste factuur nog niet betaald is. We hebben de toegang voor alle medewerkers op dit platform ingetrokken. Partners en klanten hebben nog steeds toegang tot hun gegevens.",
          "title": "Jouw account is uitgeschakeld!"
        },
        "display": "Weergave",
        "filters": "Filters",
        "generalNotifications": "Krijg notificaties voor",
        "has_access_to": "Heeft toegang tot",
        "information": "Profielinformatie",
        "informationNotificationsEmail": "Ontvang een overzicht via e-mail, inclusief alleen meldingen die je nog niet hebt gezien op het platform.",
        "informationNotificationsPlatform": "Ontvang alle notificaties in jouw persoonlijk overzicht die zich rechtsboven van je scherm bevindt",
        "informationNotificationsTitle": "Bepaal welke notificaties je wil ontvangen en via welk kanaal",
        "its_you!": "Dit ben jij!",
        "last_login": "Laatste aanmelding",
        "maintainerAccess": "Vereist toegang per project",
        "name": "Naam",
        "onPlatform": "Op Platform",
        "ownerAccess": "Heeft toegang tot alle projecten en inhoud op het {client_name} platform.",
        "password": "Wachtwoord",
        "permissions": "Toegangsrechten voor",
        "permissionsOwnerOnly": "Als projectbeheerder kan je deze actie niet uitvoeren. Vraag een {client_name} teamlid met rol Eigenaar om dit voor jou te doen.",
        "projectMaintains": "{first_name} heeft toegang tot de volgende projecten:",
        "projectMaintainsAdd": "Om toegang te verlenen, selecteer een project en voeg {first_name} toe als Beheerder bij de Informatie pagina",
        "projectMaintainsNone": "heeft momenteel geen toegang tot projecten.",
        "projectNotifications": "Voor project",
        "search_by_name_or_email": "Zoeken op naam of e-mail",
        "show_signature": "Toon handtekening",
        "signature_active": "Handtekening actief",
        "signature_info": "Deze handtekening wordt toegevoegd aan antwoorden die naar klanten en partners worden verzonden.",
        "sorting": "Sorteren",
        "viaEmail": "Via Email"
      },
      "modals": {
        "maintainers_access": {
          "accessible": "Toegankelijk",
          "description": "Wijzigingen worden automatisch opgeslagen",
          "not_accessible": "Niet toegankelijk",
          "title": "Projecttoegang bijwerken voor {first_name} {last_name}"
        }
      },
      "roles": {
        "maintainer": "Beheerder",
        "owner": "Eigenaar"
      },
      "toasts": {
        "create": "Teamlid is aangemaakt",
        "update": "Teamlid is gewijzigd"
      },
      "validation": {
        "emailTaken": "Emailadres is al in gebruik",
        "mustBeEmailAddress": "Geldig emailadres vereist",
        "needFirstName": "Voornaam vereist",
        "needLastName": "Achternaam vereist",
        "requireEmailAddress": "Email vereist",
        "role": "Selecteer toegangsrechten"
      }
    }
  }
}
